export interface RoleRefModel {
    level: number,
    name: string,
    descriptions: string[] | [],
}

export const roleRefData: RoleRefModel[] = [
    {
        level: 1,
        name: "Aministrator",
        descriptions: ["ມີສິດສູງສຸດ", "ສ້າງຜູ້ໃຊ້", "ແກ້ໄຂໄດ້ທຸກຢ່າງ",]
    },
    {
        level: 2,
        name: "MOD",
        descriptions: ["ສ້າງເອກະສານ", "ເຫັນເອກະສານທັງຫມົດ", "ເຫັນລາຍງານ"],
    },
    {
        level: 3,
        name: "Manager",
        descriptions: ["ເຫັນເອກະສານທັງຫມົດ", "ເຫັນລາຍງານທັງຫມົດ"],
    },
    {
        level: 4,
        name: "General",
        descriptions: ["ເຫັນລາຍງານທັງຫມົດ"],
    },
    {
        level: 5,
        name: "Recipient",
        descriptions: ["ເຫັນແຕ່ເອກະສານທີ່ກ່ຽວຂ້ອງ ໃນເຂດທີ່ຕົນສັງກັດ"],
    },
];